import { appConfig, getAuthToken, getCompanyId } from '$utils'
import { CoreApiClient } from '@loadedhub/core-api-sdk'

// Note that as this client is a singleton, instantiated once when then app is
// loaded, we need to make sure that properties that can change are functions
// that return the current value.
const coreApiClient = new CoreApiClient(
  {
    authToken: () => getAuthToken(),
    companyId: () => getCompanyId(),
  },
  appConfig.get<string>('mercuryApiUrl')
)

export default coreApiClient
